import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ReviewService {

  id1:string = ''

  id2:string = ''

  constructor(private fs:AngularFirestore) { }

  getReview() {
    return this.fs.collection(`menus/${this.id1}/singlemenu/${this.id2}/reviews`).valueChanges()
  }
  addReview(
    name:string,
    message:string,
    rating:number,
    email:string
  )
{
return new Promise((resolve, reject)=> {
    this.fs.collection(`menus/${this.id1}/singlemenu/${this.id2}/reviews`).add({
      name,
      message,
      rating,
      email
    }).then(()=>resolve())
  })
}

}
